import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BusinessCaseNew} from "../_models/business-case-new";
import {Observable} from "rxjs";
import {BusinessCaseDto} from "../_models/business-case-dto";
import {ServerEndpoints} from "../../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class BusinessCaseHttpService {

  constructor(private httpClient: HttpClient, @Inject("BASE_URL") private baseUrl: string) {
  }

  add(model: BusinessCaseNew): Observable<BusinessCaseDto> {
    return this.httpClient.put<BusinessCaseDto>(`${this.baseUrl}${ServerEndpoints.Inventory_BusinessCase_Add}`, model);
  }

  get(id: string): Observable<BusinessCaseDto> {
    return this.httpClient.get<BusinessCaseDto>(`${this.baseUrl}${ServerEndpoints.Inventory_BusinessCase_Get_$id$.dictReplace({id: id})}`);
  }

  list(): Observable<BusinessCaseDto[]> {
    return this.httpClient.get<BusinessCaseDto[]>(`${this.baseUrl}${ServerEndpoints.Inventory_BusinessCase_List}`);
  }

  delete(id: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}${ServerEndpoints.Inventory_BusinessCase_Delete_$id$.dictReplace({id: id})}`);
  }
}
